var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"hearder",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"search-header"},[_c('span',[_vm._v("会员总览")])])]),_c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":24}},[_c('lineCharts')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }